// apiClient.ts - React hook integration with useMsal
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest } from '../../../authConfig';

// Custom hook for silent token acquisition
export const useSilentToken = () => {
    const { instance, accounts } = useMsal();

    const acquireSilentToken = async () => {
        if (!accounts.length) {
            throw new Error('No active account');
        }

        const account = accounts[0]; // Use first account
        const tokenRequest = { loginRequest, account };

        try {
            const response = await instance.acquireTokenSilent(tokenRequest);
            // console.log(response.accessToken)
            return response.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                // Session expired - trigger login popup
                await instance.loginPopup(loginRequest);
                // Retry silent after login
                const newResponse = await instance.acquireTokenSilent(tokenRequest);
                console.log(newResponse.accessToken)
                return newResponse.accessToken;
            }
            throw error;
        }
    };

    return { acquireSilentToken };
};
